import { render } from "./ShishikiComponent.vue?vue&type=template&id=b74696b8&scoped=true&ts=true"
import script from "./ShishikiComponent.vue?vue&type=script&lang=ts"
export * from "./ShishikiComponent.vue?vue&type=script&lang=ts"

import "./ShishikiComponent.vue?vue&type=style&index=0&id=b74696b8&scoped=true&lang=css"

import exportComponent from "C:\\Dmes\\webdds-src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74696b8"]])

export default __exports__